// ─────────────────────────────────────────────────────────────────────────────
// RF-010 / RF-114 / PLAN WP-U6 — Carga masiva del padrón de Europa y EE. UU. por CSV.
//
// Consume POST v1/users/europe-usa-import, que escribe en `users`. Antes había DOS opciones:
//
//   · "Estándar (MX / Central / LATAM / FOSE / US)" → bulk-import. **Retirada (D-U22)**: esa gente
//     ya no se carga a mano, la trae SuccessFactors dos veces al día. Dejar el botón invitaría a
//     cargar por Excel a alguien que el sync va a sobrescribir seis horas después.
//   · "Europa" → europe-import, que escribía en la colección `europe_users`, una segunda fuente de
//     verdad que nadie más leía (0 documentos hoy). La persona cargada por ahí no aparecía en
//     `users` y por tanto **no se la podía reconocer**.
//
// Rediseño 2026-08-10: el panel inline con vista previa embebida se reemplaza por un wizard modal
// de 4 pasos (mismo lenguaje visual que la carga masiva de Reconocimientos), porque el panel viejo
// colapsaba con más de 4000 filas — la causa real era N+1 en el backend (ver
// ImportEuropeUsaCommandHandler), ya corregida; este componente solo cambia de UI.
// ─────────────────────────────────────────────────────────────────────────────
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AdminSection } from './adminShared';
import { AdminBulkUsersWizardModal } from '../adminBulkUsers/AdminBulkUsersWizardModal';

export function AdminBulkUsers() {
  const { t } = useTranslation('recognition');
  const [isWizardOpen, setIsWizardOpen] = useState(false);

  return (
    <AdminSection
      title={t('admin.bulkUsers.title')}
      description={t('admin.bulkUsers.descLong')}
    >
      <div className="adm-toolbar">
        <button type="button" className="btn btn--primary" onClick={() => setIsWizardOpen(true)}>
          <i className="fas fa-file-csv" /> {t('admin.bulkUsers.openWizard')}
        </button>
      </div>
      {isWizardOpen && <AdminBulkUsersWizardModal onClose={() => setIsWizardOpen(false)} />}
    </AdminSection>
  );
}

export default AdminBulkUsers;
